import { createContext, use, type ReactNode } from 'react';

const CurrentUserSubContext = createContext<string | null>(null);

/**
 * A casca informa o `sub` de quem está logado (o `userSubId` do legado, `useIdentity()`). Só o `sub`:
 * nome e e-mail não passam por aqui.
 */
export function CurrentUserProvider({ sub, children }: { readonly sub: string | null; readonly children: ReactNode }) {
  return <CurrentUserSubContext value={sub}>{children}</CurrentUserSubContext>;
}

/** `sub` de quem está logado, para marcar "Você" numa lista. Sem sessão (ou fora da casca), `null`. */
export function useCurrentUserSub(): string | null {
  return use(CurrentUserSubContext);
}
